import { render, staticRenderFns } from "./emergencySuppliesDetail.vue?vue&type=template&id=1e80bda8&scoped=true&"
import script from "./emergencySuppliesDetail.vue?vue&type=script&lang=js&"
export * from "./emergencySuppliesDetail.vue?vue&type=script&lang=js&"
import style0 from "./emergencySuppliesDetail.vue?vue&type=style&index=0&id=1e80bda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e80bda8",
  null
  
)

export default component.exports